import { Component, OnInit, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { LoginService } from "../login.service";
import { AuthService } from "app/auth/auth.service";
import Swal from 'sweetalert2';

@Component({
  selector: 'app-autenticacion',
  templateUrl: './autenticacion.component.html',
  styleUrls: ['./autenticacion.component.scss']
})
export class AutenticacionComponent implements OnInit {

  claveQR: string = "";
  resultado: boolean;
  procesoIniciado = false;
  validando = false;
  pasoActual: number;
  asciiLocal: string;
  usuariosChecksum: any;
  saltarQR: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public datos: any,
    public dialogRef: MatDialogRef<AutenticacionComponent>,
    private loginService: LoginService,
    private authService: AuthService
  ) { }

  ngOnInit() {
    // if(localStorage.getItem('checksum')){
    //   this.usuariosChecksum = JSON.parse(localStorage.getItem('checksum'));
    //   let datosChecksumUsuario = this.usuariosChecksum.find(item => item.user == this.datos.user);
    //   if(datosChecksumUsuario != undefined){
    //     this.pasoActual = 1;
    //     this.asciiLocal = datosChecksumUsuario.integrity;
    //   }
    // }
    if(this.datos.codeActive){
      this.saltarQR = true;
    }
  }

  paso2(){
    const datos = {
      ascii: this.asciiLocal != undefined ? this.asciiLocal : this.datos.ascii,
      token: this.claveQR,
      user: this.datos.user,
      password: this.datos.password
    };
    this.validando = true;
    this.procesoIniciado = true;
    setTimeout(() => {
      this.loginService.dosPasos(datos).subscribe((respuesta:any) => {
        console.log("dosPasos:",respuesta);
        this.validando = false;
        this.resultado = respuesta.success;
        if(respuesta.success){
          setTimeout(() => {
            this.authService.login2FA_paso3(respuesta);
            this.dialogRef.close();
            // this.guardaDatosChecksum(datos.user, datos.ascii);
          }, 2000);
        }
      });
    }, 1500);
  }

  guardaDatosChecksum(user:string, integrity:string){
    if(this.usuariosChecksum != undefined){ //si el arreglo ya existe
      let datosChecksumUsuario = this.usuariosChecksum.find(item => item.user == this.datos.user);
      if(datosChecksumUsuario == undefined){
        this.usuariosChecksum.push({
          user,
          integrity
        });
      } else{
        if(this.asciiLocal == undefined){
          datosChecksumUsuario.integrity = integrity;
        }
      }
      localStorage.setItem('checksum', JSON.stringify(this.usuariosChecksum));
    } else{ //si el arreglo no existe porque es la priemra ver que se va a guardaReactivo
      if(this.asciiLocal == undefined){ //si no hay una version previa de asciilocal
        this.usuariosChecksum = [];
        this.usuariosChecksum.push({
          user,
          integrity
        });
        localStorage.setItem('checksum', JSON.stringify(this.usuariosChecksum));
      }
    }
  }

  salir() {
    this.dialogRef.close(this.resultado);
  }

}
